export const SET_WELCOME_DATA = 'SET_WELCOME_DATA';
export const GET_WELCOME_DATA = 'GET_WELCOME_DATA';
export const SET_RECENT_POPUP_STRATEGY = 'SET_RECENT_POPUP_STRATEGY';
export const SET_WELCOME_INIT = 'SET_WELCOME_INIT';
